// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__1arJ3","icon":"link_icon__3EhP1","linkContent":"link_linkContent__nkgfu"};